<template>
  <div class="seek">
    <div class="pull-left seekDropdown dropdown">
      <button class="btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer" type="button">
        <span>{{seekLan.account}}</span>
      </button>
    </div>
    <div class="pull-left form-group">
      <input type="text" class="form-control hui-form-control" v-model="seekDropdown.seekStr" @keyup.enter="emitSeek" :placeholder="seekLan.seek" v-focus>
    </div>
    <div class="pull-left btn btn-default btn-primary" @click="emitSeek">{{seekLan.seek}}</div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import { mapState } from "vuex"

  export default { 
    props: [
      "seekDropdown"
    ],
    data () {
      return {}
    },
    directives: { // 自定义指令 v-focus 让文本框自动聚焦
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    },
    mounted () {
    },
    computed: {
      seekLan () {
        return this.translate(this.LANGUAGE, "commissionSeek")
      },
      ...mapState(["LANGUAGE"])
    },
    methods: {
      emitSeek () {
        this.$emit("seek", this.seekDropdown.seekStr)
      },
    },
    components: {
    }
  }
</script>

<style lang="scss" type="text/scss">
  .seek{
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    .seekDropdown{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      .dropdown-toggle{
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
    }
    .form-group{
      display: inline-block;
      vertical-align: top;
      position: relative;
      margin: 0;
      .form-control{
        min-width: 145px;
        font-size: 13px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-default{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// relationshipSeek.vue?6bf8cc44